import { openEntityDialog } from '@/constants/states';
import { saveStates } from '@/constants/lifecycle';
import {
  alignFieldsToForm,
  assignFormLinksEditProps,
  assignFormObjectsEditProps,
  crushFormProps,
} from '@/forms/state/state';
import { assignIfExists, assignValue } from '@/utils/resultsHelper';
import { datasetPerms } from '../../sharing/state/state';

export const activeCatalogueFieldArray = () => ({
  ...openEntityDialog,
  activeFieldName: '',
  activeIndex: '',
  items: [],
  isDirty: false,
  isEditing: false,
  linksOpen: false,
  permissions: datasetPerms(),
  ...saveStates,
});

export const catalogueObjectsDialogState = (
  catalogueFieldItems,
  items,
  isEditing,
  {
    activeIndex,
    activeFieldName,
    category,
    code,
    permissions,
    template,
  },
) => {
  const props = {
    category, code, activeFieldName, activeIndex, template, open: true, items, permissions,
  };
  if (isEditing) {
    const errors = assignFormObjectsEditProps(template, activeFieldName, items);
    errors.forEach((e) => catalogueFieldItems.saveErrors.push(e));
    props.isEditing = true;
  }

  assignIfExists(catalogueFieldItems, props);
};

export const catalogueLinksDialogState = (
  catalogueFieldItems,
  items,
  isEditing,
  {
    activeIndex,
    activeFieldName,
    category,
    code,
    permissions,
    template,
  },
) => {
  if (isEditing) {
    const errors = assignFormLinksEditProps(template, activeFieldName, items);
    errors.forEach((e) => catalogueFieldItems.saveErrors.push(e));
  }

  assignIfExists(catalogueFieldItems, {
    category, code, activeFieldName, activeIndex, template, linksOpen: true, items, permissions, isEditing: true,
  });
};

const crushCatalogueProps = (dataset, template) => {
  const copy = crushFormProps(dataset.catalogue);
  const { errors, redundant } = alignFieldsToForm(copy, template);
  redundant.forEach((key) => delete copy[key]);
  assignValue(dataset, 'catalogue', copy);

  return errors.length > 0;
};

export const assignCatalogueProps = (dataset, template) => {
  const { errors } = alignFieldsToForm(dataset.catalogue, template);
  errors.forEach((e) => { dataset.saveErrors.push(e); });

  return errors.length > 0;
};

export default crushCatalogueProps;
